import type { TErefStatus } from "types/elevationReferences.type"

const layeredPath =
	"M11 8.82518L6.415 10.9052C6.28472 10.9646 6.14319 10.9954 6 10.9954C5.85681 10.9954 5.71528 10.9646 5.585 10.9052L1 8.82518M11 6.32518L6.415 8.40518C6.28472 8.4646 6.14319 8.49536 6 8.49536C5.85681 8.49536 5.71528 8.4646 5.585 8.40518L1 6.32518M6.415 1.09018C6.28472 1.03075 6.14319 1 6 1C5.85681 1 5.71528 1.03075 5.585 1.09018L1.3 3.04018C1.21127 3.0793 1.13584 3.14338 1.08288 3.22461C1.02992 3.30584 1.00173 3.40071 1.00173 3.49768C1.00173 3.59465 1.02992 3.68952 1.08288 3.77075C1.13584 3.85198 1.21127 3.91606 1.3 3.95518L5.59 5.91018C5.72028 5.9696 5.86181 6.00036 6.005 6.00036C6.14819 6.00036 6.28972 5.9696 6.42 5.91018L10.71 3.96018C10.7987 3.92106 10.8742 3.85698 10.9271 3.77575C10.9801 3.69452 11.0083 3.59965 11.0083 3.50268C11.0083 3.40571 10.9801 3.31084 10.9271 3.22961C10.8742 3.14838 10.7987 3.0843 10.71 3.04518L6.415 1.09018Z"

const topLayerPath =
	"M6.415 1.09018C6.28472 1.03075 6.14319 1 6 1C5.85681 1 5.71528 1.03075 5.585 1.09018L1.3 3.04018C1.21127 3.0793 1.13584 3.14338 1.08288 3.22461C1.02992 3.30584 1.00173 3.40071 1.00173 3.49768C1.00173 3.59465 1.02992 3.68952 1.08288 3.77075C1.13584 3.85198 1.21127 3.91606 1.3 3.95518L5.59 5.91018C5.72028 5.9696 5.86181 6.00036 6.005 6.00036C6.14819 6.00036 6.28972 5.9696 6.42 5.91018L10.71 3.96018C10.7987 3.92106 10.8742 3.85698 10.9271 3.77575C10.9801 3.69452 11.0083 3.59965 11.0083 3.50268C11.0083 3.40571 10.9801 3.31084 10.9271 3.22961C10.8742 3.14838 10.7987 3.0843 10.71 3.04518L6.415 1.09018Z"

const STATUS_COLOR: Record<TErefStatus, { stroke: string; fill: string }> = {
	work_in_progress: { stroke: "var(--clr-midGray)", fill: "none" },
	reviewed: { stroke: "var(--clr-main)", fill: "var(--clr-quotationIconReviewedBg)" },
	in_quotation: {
		stroke: "var(--clr-quotationIconInQuotation)",
		fill: "var(--clr-quotationIconInQuotationBg)",
	},
}

type Props = { status?: TErefStatus }

export const ErefStatusIcon = ({ status = "work_in_progress" }: Props) => {
	const { stroke, fill } = STATUS_COLOR[status]

	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 12 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{fill !== "none" ? <path d={topLayerPath} fill={fill} /> : null}
			<path d={layeredPath} stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
